export const removeHash = (value: string) => (value && value[0] === '#' ? value.slice(1) : value)
export const addHash = (value: string) => (value && value[0] === '#' ? value : `#${value}`)
